import i18next from "i18next";

import { useNavigate } from "react-router";
import FileUploader from "../components/FileUploader";
import Label from "../components/Label";
import SimpleDialog from "../components/SimpleDialog";
import { routes } from "../utils";
import { useState } from "react";
import { downloadTemplate } from "../services/samplesServices";

export default function MassiveCreate() {
	const [errors, setErrors] = useState<string>();
	const [loading, setLoading] = useState(true);

	const navigate = useNavigate();

	const goBack = () => navigate(routes.DASHBOARD);

	return (
		<SimpleDialog open={true} onClose={!loading ? goBack : undefined}>
			<Label isTitle text={i18next.t("upload-file")} />
			<p>{i18next.t("upload-file-description")}</p>
			<a href="#" onClick={() => downloadTemplate()}>
				{i18next.t("download-template") + "."}
			</a>
			{errors && (
				<pre
					style={{ maxHeight: 200 }}
					className="overflow-auto rounded-1 text-danger bg-danger-subtle px-2 mt-2"
				>
					{i18next.t(errors)}
				</pre>
			)}
			<FileUploader
				setLoading={setLoading}
				className="mt-3"
				onCancel={goBack}
				onUpload={goBack}
				setErrors={setErrors}
			/>
		</SimpleDialog>
	);
}
